import { z } from 'zod';

// Information Item Schema
export const tokenResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  status: z.string(),
  data: z.string(),
});

// Types
export type tokenResponse = z.infer<typeof tokenResponseSchema>;
